var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"homeTitle"},[_vm._v("\n\t\t在线考试系统\n\t"),_c('p',{staticClass:"lisb"},[_vm._v("如果因正常考试流程验证来到此页面，说明某个验证环节出现异常，请点击 "),_c('a',{attrs:{"href":"/exam/"}},[_vm._v("重新验证")]),_vm._v(" 进入考试。")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fc8026f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/index.vue
// module id = null
// module chunks = 